import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from "react";
import { normalizeLocale } from "../config.js";
import { createTranslator } from "../i18n/translator.js";
import { AuthWidgetLeft } from "./AuthWidgetLeft.js";
import { AuthWidgetShell } from "./AuthWidgetShell.js";
import { ForgotForm } from "./forgot/index.js";
import { LoginForm } from "./login/index.js";
import { RegisterForm } from "./register/index.js";
import Toast from "./Toast/index.js";
export const AuthWidget = ({ state, onClose }) => {
    const [action, setAction] = useState(state.action);
    const [messageApi, contextHolder] = Toast.useToast();
    const locale = normalizeLocale(state.options.language);
    const t = useMemo(() => createTranslator(locale), [locale]);
    const mode = resolveMode();
    const returnUrl = state.options.returnUrl || window.location.href;
    const handleClose = useCallback((reason) => {
        setAction("login");
        messageApi.destroy();
        onClose(reason);
    }, [messageApi, onClose]);
    useEffect(() => setAction(state.action), [state.action]);
    if (!state.open)
        return null;
    const formProps = {
        config: state.config,
        locale,
        options: state.options,
        returnUrl,
        setAction,
        showToast: messageApi.open,
        t,
        onClose: handleClose,
    };
    return (_jsx(AuthWidgetShell, { mode: mode, mask: state.options.mask, maskClosable: state.options.maskClosable, onClose: handleClose, children: (requestClose) => {
            const shellFormProps = Object.assign(Object.assign({}, formProps), { onClose: requestClose });
            return (_jsxs(_Fragment, { children: [_jsx(AuthWidgetLeft, { leftRender: state.options.leftRender, slogan: t("signInCommon.slogan") }), _jsxs("div", { id: "action", className: "action", children: [contextHolder, action === "forgot" && (_jsx("button", { className: "backArrow", type: "button", "aria-label": "Back", onClick: () => setAction("login"), children: _jsx("span", { className: "visuallyHidden", children: "Back" }) })), _jsxs("div", { className: "actionWrapper", children: [action === "login" && _jsx(LoginForm, Object.assign({}, shellFormProps)), action === "register" && _jsx(RegisterForm, Object.assign({}, shellFormProps)), action === "forgot" && _jsx(ForgotForm, Object.assign({}, shellFormProps))] }), _jsxs("div", { className: "termsConditions", children: [t("signInCommon.bySigning"), " ", _jsx("a", { children: t("signInCommon.privacyPolicy") }), " ", t("signInCommon.and"), " ", _jsx("a", { children: t("signInCommon.TermsConditions") })] })] }), _jsx("button", { className: "iconClose", type: "button", "aria-label": "Close", onClick: () => requestClose("cancel"), children: _jsx("span", { className: "visuallyHidden", children: "Close" }) })] }));
        } }));
};
const resolveMode = () => {
    return window.innerWidth <= 768 ? "drawer" : "modal";
};
//# sourceMappingURL=AuthWidget.js.map